import type { Dispatch, FC, SetStateAction } from 'react';
import { Flex } from '@eqi-investimentos/react';
import {
  ContentMode,
  ContentModeEnum,
  type Content,
} from '@/modules/Content/interface/Content';
import { AudioPlayer } from '@/components/sections/Player/AudioPlayer';
import { IfRender } from '@/utils/jsx';

export const ContentAudioMode: FC<ContentAudioModeProps> = ({
  authors,
  content,
  contentMode,
  progress,
  sendProgress,
  setContentMode,
}) => {
  return (
    <IfRender condition={contentMode === ContentModeEnum.AUDIO}>
      <Flex
        alignItems="center"
        justifyContent="center"
        w="full"
        bgColor="background.alwaysDark"
      >
        <Flex w="full" maxW="57rem" overflow="hidden">
          {content.audio_urls?.medium && (
            <AudioPlayer
              title={content.title}
              authors={authors}
              src={content.audio_urls?.medium ?? content.audio_urls?.low}
              srcHD={content.audio_urls?.high ?? null}
              autoPlay
              nextSlug={content.next_content}
              previousSlug={content.previous_content}
              progress={progress}
              sendWatchProgress={sendProgress}
              hasVideoMode={content.has_video}
              setVideoMode={() => setContentMode(ContentModeEnum.VIDEO)}
              hasTextMode={content.has_text}
              setTextMode={() => setContentMode(ContentModeEnum.TEXT)}
              content={content}
            />
          )}
        </Flex>
      </Flex>
    </IfRender>
  );
};

type ContentAudioModeProps = {
  authors: string;
  content: Content;
  contentMode: ContentMode;
  progress: number;
  sendProgress: (progress: number, duration: number) => Promise<void>;
  setContentMode: Dispatch<SetStateAction<ContentMode>>;
};
